let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7mIf9"), load("jXweD"), load("ffQaD"), load("kvRbA"), load("dtu6b")]).then(() => parcelRequire('kWbha'));